"use client";
import {
  MenubarProvider
} from "../__chunks/L3MGZQ3I.js";
import "../__chunks/E5PXVSMA.js";
import "../__chunks/WSQNIDGC.js";
import "../__chunks/UVQLZ7T5.js";
import "../__chunks/TCAGH6BH.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import "../__chunks/HKOOKEDE.js";
import "../__chunks/2GXGCHW6.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import {
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/menu/menu-bar-provider.tsx
import { useEffect } from "react";
import { jsx } from "react/jsx-runtime";
function MenuBarProvider(props = {}) {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      console.warn(
        "MenuBarProvider is deprecated. Use MenubarProvider instead.",
        "See https://ariakit.org/reference/menubar-provider"
      );
    }
  }, []);
  return /* @__PURE__ */ jsx(MenubarProvider, __spreadValues({}, props));
}
export {
  MenuBarProvider
};
